import { Pen, Trash2 } from "lucide-react";
import { Icon } from "../../ui/Icon.js";
import { Surface } from "../../ui/Surface.js";
import { Toolbar } from "../../ui/Toolbar.js";
import Tooltip from "../../ui/Tooltip/index.js";

export type LinkPreviewPanelProps = {
  url: string;
  onEdit: () => void;
  onClear: () => void;
};

export const LinkPreviewPanel = ({
  onClear,
  onEdit,
  url,
}: LinkPreviewPanelProps) => {
  return (
    <Surface className="flex items-center gap-2 p-2">
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm underline break-all"
      >
        {url}
      </a>
      <Toolbar.Divider />
      <Tooltip title="Edit link">
        <Toolbar.Button type="button" onClick={onEdit}>
          <Icon icon={Pen} />
        </Toolbar.Button>
      </Tooltip>
      <Tooltip title="Remove link">
        <Toolbar.Button type="button" onClick={onClear}>
          <Icon icon={Trash2} />
        </Toolbar.Button>
      </Tooltip>
    </Surface>
  );
};
